import {  combineReducers, configureStore } from '@reduxjs/toolkit';
import hooxReducer from './hooxSlice';
import contentReducer from './pages/content/contentSlice';

const reducer = combineReducers({
    content: contentReducer,
    hoox: hooxReducer
});

export default configureStore({ reducer });